import cx from 'classnames'

import { SanityPrintSlot } from '@data/sanity/queries/types/print'

import PrintConfiguratorProgressIndicatorItem from './progress-indicator-item'
import { useMemo } from 'react'

interface Item {
  isSelected: boolean
  title: string
  url?: string
  onClick?: () => void
}

interface PrintConfiguratorProgressIndicatorProps {
  slots: SanityPrintSlot[]
  activeSlotIndex: number
  productUrl: string
  firstStepLabel: string
  setActiveSlotIndex: (value: number) => void
  className?: string
}

const PrintConfiguratorProgressIndicator = ({
  slots,
  activeSlotIndex,
  productUrl,
  firstStepLabel,
  setActiveSlotIndex,
  className,
}: PrintConfiguratorProgressIndicatorProps) => {
  const items = useMemo(() => {
    const productItem: Item = {
      isSelected: true,
      title: firstStepLabel,
      url: productUrl,
    }
    const slotItems = slots.map((slot, index) => {
      const slotItem: Item = {
        isSelected: index <= activeSlotIndex,
        title: slot.name,
        onClick: () => {
          setActiveSlotIndex(index)
        },
      }

      return slotItem
    })

    return [productItem, ...slotItems]
  }, [activeSlotIndex, firstStepLabel, productUrl, setActiveSlotIndex, slots])

  return (
    <div
      className={cx(
        'flex justify-center max-w-full py-4 border-b border-gray-light',
        className,
      )}
    >
      <div
        className="flex"
        style={{
          width: items.length * 100,
        }}
      >
        {items.map((item, index) => (
          <PrintConfiguratorProgressIndicatorItem
            key={index}
            title={item.title}
            isSelected={item.isSelected}
            url={item.url}
            onClick={item.onClick}
            showLine={index > 0}
            className="flex-1"
          />
        ))}
      </div>
    </div>
  )
}

export default PrintConfiguratorProgressIndicator
